<template>
  <div class="sign-in-container">
    <proa-card flat class="sign-in-card">
      <div class="tab-wrapper">
        <div>
          <router-link :to="{ name: 'signUp' }">{{ $t('common.signUp') }}</router-link>
        </div>
        <div class="active">{{ $t('common.signIn') }}</div>
      </div>
      <div class="form-wrapper">
        <router-link :to="{ name: 'root' }" class="d-block mb-4 pb-2">
          <img :src="require('@/assets/images/logo.png')" class="logo"/>
        </router-link>
        <div class="mb-4 pb-2 font-weight-w6">{{ $t('pages.signIn.formCaption') }}</div>
        <form novalidate @submit.prevent="onSubmitSignIn">
          <div class="mb-4">
            <proa-input
              v-model="email"
              type="email"
              :placeholder="$t('models.user.attributes.email')"
              dark
            />
          </div>
          <div style="margin-bottom: 20px;">
            <proa-input
              v-model="password"
              type="password"
              :placeholder="$t('models.user.attributes.password')"
              dark
            />
          </div>
          <span v-if="unauthorized" class="unauthorized-message mb-3">
            {{ unauthorizedMessage }}
          </span>
          <span v-else-if="internalServerError" class="unauthorized-message mb-3">
            {{ $t('pages.signIn.internalServerErrorMessage') }}
          </span>
          <div class="py-2 mb-4">
            <proa-button
              class="w-100"
              type="submit"
              variant="primary"
              :loading="signInRequesting"
            >
              {{ $t('common.signIn') }}
            </proa-button>
          </div>
          <div class="pt-1">
            <router-link :to="{ name: 'forgotPassword' }">{{ $t('pages.signIn.forgotPassword') }}</router-link>
          </div>
        </form>
      </div>
    </proa-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SignIn',
  data () {
    return {
      email: '',
      password: '',
      signInRequesting: false,
      unauthorized: false,
      unauthorizedMessage: '',
      internalServerError: false
    }
  },
  computed: {
    ...mapGetters({
      httpError: 'httpError',
      signedInUser: 'auth/signedInUser'
    })
  },
  methods: {
    async onSubmitSignIn() {
      this.signInRequesting = true
      await this.signIn({
        email: this.email,
        password: this.password
      })
      this.signInRequesting = false
      if (this.httpError) {
        if (this.httpError?.response?.status == 401) {
          this.unauthorized = true
          this.unauthorizedMessage = this.httpError?.response.data.errors[0]
        } else {
          this.internalServerError = true
        }
        return
      }
      if (this.signedInUser) {
        if (this.$route.query.redirect) {
          this.$router.push({ path: this.$route.query.redirect })
        } else {
          this.$router.push({ name: 'mySpace' })
        }
      }
    },
    ...mapActions({
      signIn: 'auth/signIn'
    })
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";
@import "@/styles/variables";

.sign-in-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sign-in-card {
  width: 100%;

  @include mq(sm) {
    width: 400px;
  }
}

.tab-wrapper {
  width: 100%;
  height: 50px;
  display: flex;

  div {
    flex-basis: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $light-gray-color;
    font-size: 16px;
    font-weight: 600;

    &.active {
      background-color: white;
      color: $primary-color;
    }

    a {
      color: $light-text-color;
      text-decoration: none;
    }
  }
}

.form-wrapper {
  padding: 40px 50px;
  text-align: center;

  .logo {
    width: 150px;
  }
}

.unauthorized-message {
  display: flex;
  justify-content: center;
  white-space: pre-wrap;
  font-size: 13px;
  color: $error-color;
}
</style>
